export default __webpack_public_path__ + "static/media/Krowd_logo.b697aa64.jpg";